// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var document_type_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "document_type_name"), null));
  if (document_type_name.TAG === /* Ok */0) {
    var document_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "document_status"), null));
    if (document_status.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                document_type_name: document_type_name._0,
                document_status: document_status._0
              }
            };
    }
    var e = document_status._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".document_status" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = document_type_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".document_type_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function res_decode(v) {
  return Decco.listFromJson(t_decode, v);
}

export {
  t_decode ,
  res_decode ,
  
}
/* No side effect */
